import { render, staticRenderFns } from "./ArchivedCampaignsComponent.vue?vue&type=template&id=2367a038&scoped=true&"
import script from "./ArchivedCampaignsComponent.vue?vue&type=script&lang=js&"
export * from "./ArchivedCampaignsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedCampaignsComponent.vue?vue&type=style&index=0&id=2367a038&prod&scoped=true&lang=scss&"
import style1 from "./ArchivedCampaignsComponent.vue?vue&type=style&index=1&id=2367a038&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2367a038",
  null
  
)

export default component.exports